import { styled } from "styled-components";
import Layout from "../components/Layout";
import posts from "../posts.json";
import ShortBlog from "./ShortBlog";
import { Content } from "./BlogList";
import { useParams } from "react-router-dom";

function Blog() {
  const selected = useParams();
  const blogs = selected.category ? posts.filter(p =>  p.category && p.category.trim() === selected.category) : [...posts];
  return (
    <Layout>
      <BlogWrapper className="layoutWrapper">
        <Content>
          {blogs.map((post) => {
            return <ShortBlog key={post.id} post={post} />;
          })}
        </Content>
      </BlogWrapper>
    </Layout>
  );
}

export default Blog;

const BlogWrapper = styled.section`
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
`;
